import { useEffect } from "react";
import { IPageAndSearchMeta } from "../interfaces-and-types";
import { useApiPagedMeta } from "./useApiPagedMeta";

export function useApiPagedMetaSync(page_meta: IPageAndSearchMeta | undefined) {
  const { setApiPageMeta } = useApiPagedMeta();

  useEffect(() => {
    page_meta && setApiPageMeta(page_meta);
  }, [
    page_meta?.page,
    page_meta?.page_size,
    page_meta?.page_count,
    page_meta?.item_count,
    page_meta?.search,
  ]);
}
